<template>
  <div>
    <CommonHeader :page="'Paramètrage'" />
    <GStockLoader :loading="settingsLoader" />
    <b-container
      fluid
      v-if="passcode == appTechName.split('').reverse().join('')"
    >
      <b-row class="my-1" style="margin-top: 25px !important">
        <b-col sm="3">
          <label for="appLogo"><code>Logo de l'application</code></label>
        </b-col>
        <b-col sm="9">
          <div class="w-12 h-12 image-fit text-center mt-5">
            <img
              v-if="showImage"
              id="appLogo"
              alt="Logo de l'application"
              class="rounded-full"
              width="300"
              :src="appLogo"
            />
          </div>
          <div class="mx-auto cursor-pointer relative mt-5">
            <input
              id="fileToUploadLogo"
              type="file"
              class="w-full h-full top-0 left-0 absolute opacity-0"
            />
          </div>
        </b-col>
      </b-row>
      <b-row class="my-1" style="margin-top: 25px !important">
        <b-col sm="3">
          <label :for="`appName`"> <code>Nom de l'application</code>: </label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            :id="`appName`"
            type="text"
            placeholder="Nom de l'application"
            v-model="form.appName"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-1" style="margin-top: 25px !important">
        <b-col sm="3">
          <label :for="`appTechName`">
            <code>Nom technique de l'application</code>:
          </label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            :id="`appTechName`"
            type="text"
            placeholder="Nom technique de l'application"
            v-model="form.appTechName"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-1" style="margin-top: 25px !important">
        <b-col sm="3">
          <label :for="`defaultPercentage`">
            <code>Pourcentage par défaut</code>:
          </label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            :id="`defaultPercentage`"
            type="number"
            placeholder="Pourcentage par défaut"
            v-model="form.defaultPercentage"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-1" style="margin-top: 25px !important">
        <b-col sm="3">
          <label :for="`defaultValidity`">
            <code>Validité par défaut</code>:
          </label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            :id="`defaultValidity`"
            type="number"
            placeholder="Validité par défaut"
            v-model="form.defaultValidity"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-1" style="margin-top: 25px !important">
        <b-col sm="3">
          <label :for="`appContact`">
            <code>Contacte de boutique</code>:
          </label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            :id="`appContact`"
            type="text"
            placeholder="Contacte de boutique"
            v-model="form.appContact"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-1" style="margin-top: 25px !important">
        <b-col sm="3">
          <label :for="`appContact`">
            <code>Inclure le prix de produit dans le contrat client</code>:
          </label>
        </b-col>
        <b-col sm="9">
          <b-form-checkbox
            v-model="form.isPriceIncluded"
            name="check-button"
            switch
          />
        </b-col>
      </b-row>
      <div>
        <b-button size="lg" variant="primary" @click="updateSettings(form)"
          >Valider</b-button
        >
      </div>
    </b-container>
    <b-container fluid v-else>
      <b-row class="my-1" style="margin-top: 25px !important">
        <b-col sm="3">
          <label :for="`passcode`">
            <code>Veuillez entrez le passcode</code>:
          </label>
        </b-col>
        <b-col sm="9">
          <b-form-input
            :id="`passcode`"
            type="text"
            placeholder="Passcode"
            v-model="passcode"
          ></b-form-input>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import GStockLoader from "@/components/Loader";
import CommonHeader from "@/components/CommonHeader";
import { postFile } from "@/mixins/api";
import constants from "@/mixins/constants";
export default {
  components: {
    GStockLoader,
    CommonHeader,
  },
  mixins: [constants],
  data() {
    return {
      passcode: "",
      form: {
        appName: "",
        appTechName: "",
        defaultPercentage: "",
        defaultValidity: "",
        appContact: "",
        isPriceIncluded: false,
      },
      showImage: true,
    };
  },
  watch: {
    passcode: {
      handler: function (newVal) {
        if (newVal == this.appTechName.split("").reverse().join("")) {
          setTimeout(() => {
            this.bindClickListner();
          }, 0);
        }
      },
      immediate: true,
    },
    updatedSetti: {
      handler: function (newVal) {
        this.form.appName = this.applicationName;
        this.form.appTechName = this.appTechName;
        this.form.defaultPercentage = this.defaultPercentageText;
        this.form.appContact = this.appContact;
        this.form.defaultValidity = this.defaultValidity;
        this.form.isPriceIncluded = this.isPriceIncluded;
      },
      immediate: true,
    },
  },
  methods: {
    bindClickListner() {
      const fileToUpload = document.getElementById("fileToUploadLogo");
      fileToUpload.addEventListener("change", () => {
        console.log("here");
        const payload = fileToUpload.files[0];
        postFile("uploadLogo", payload).then((res) => {
          console.log("here1");
          this.showImage = false;
          this.settingsLoader = true;
          setTimeout(() => {
            this.$router.go();
          }, 3000);
        });
      });
    },
  },
};
</script>
<style lang="scss">
</style>